var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":require("../assets/default_gift.png")}}),_c('button',{staticClass:"button is-primary",on:{"click":_vm.gotToMyList}},[_vm._v("Los geht's!")])])}
var staticRenderFns = []

export { render, staticRenderFns }